























































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Search from '@/app/ui/components/Search/index'
import ModalDeleteAll from '@/app/ui/components/ModalDeleteAll/index.vue'
import { UserModule } from '@/app/store/modules/user'
import { MasterModule } from '@/app/store/modules/master'
import { AuthModule } from '@/app/store/modules/auth'
import vSelect from 'vue-select'
import { ModelSelect } from 'vue-search-select'
import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import {
  required,
  minLength,
  maxLength,
  sameAs,
} from 'vuelidate/lib/validators'
import { getSalesCode } from '@/utils/cookies'
@Component({
  components: {
    search: Search,
    'modal-delete-all': ModalDeleteAll,
    'vue-select': ModelSelect,
  },
})
export default class extends Vue {
  @Prop({}) public selected
  @Prop({}) public funcSearch
  @Prop({}) public isDisabledExport
  @Prop({}) public isDisabled
  @Prop({}) public clearRowSelected
  @Prop({}) public textSearch
  @Prop({}) public linkExport
  @Prop({}) public storageType

  public $v: Vuelidate
  public searchInput: string = ''
  private resetSearch() {
    this.searchInput = ''
    this.funcSearch(this.searchInput)
  }

  public storageSelected: boolean = false
  @Watch('storageSelected')
  public onStorageChanged(value: boolean, oldValue: boolean) {
    if (this.storageSelected === false) {
      UserModule.paginationParam.filter.type = 'dnet'
      UserModule.paginationParamsExport.filter.type = 'dnet'
      UserModule.paginationParamsExport.search = ''
      UserModule.paginationParam.search = ''
      this.searchInput = ''
      this.storageTypes()
      this.resetPagination()
      UserModule.getExportData()
      UserModule.getUserDataDNET()
    } else {
      UserModule.paginationParam.filter.type = 'sfid'
      UserModule.paginationParamsExport.filter.type = 'sfid'
      UserModule.paginationParamsExport.search = ''
      UserModule.paginationParam.search = ''
      this.searchInput = ''
      this.resetPagination()
      this.storageTypes()
      UserModule.getExportData()
      UserModule.getUserDataSFID()
    }
  }

  public resetPagination() {
    UserModule.paginationParam.paging.page = 1
  }

  public hasFiles = {
    file_name: '',
    file_byte: '',
  }

  public postFile(event) {
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        const hash = e.target.result.split(',')
        this.hasFiles = {
          file_name: input.files[0].name,
          file_byte: hash.length ? hash[1] : '',
        }
      }
      reader.readAsDataURL(input.files[0])
    }
  }

  public storageTypes() {
    this.storageType = UserModule.paginationParam.filter.type
  }

  // checkbox Need Register
  public needregister: string = 'false'

  // FIlter By Dealer Group
  @Validate({})
  public dealerGroup: string = ''
  public dealerGroupId: string = ''
  public byDealerGroup(text) {
    const find = this.dealerGroupOptions.find((e) => e.name === text)
    const index = this.dealerGroupOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerGroup()
    }
    if (this.dealerGroupOptions.length > 0) {
      this.dealerGroupId = this.dealerGroupOptions.find(
        (e) => e.name === text
      ).id
    }
  }
  public dealerGroupOptions: any = []
  public get dealerBranchGroup() {
    this.dealerGroupOptions = MasterModule.DealerGroupData.data
    //  console.log('cek dealer group')
    //  console.log(this.dealerGroupOptions)
    return MasterModule.DealerGroupData
  }

  public sizes: any = []
  public positions: any = []
  public dealerName: any = []
  public selectedDealer: any = []
  public selectedDealerGroup: any = []

  public clearfield() {
    if (this.salescode === 'MMKSI-') {
      this.dealerGroup = ''
    } else {
      this.dealerGroup = ''
    }
  }

  public getSelectedDealerGroup() {
    if (this.dealerGroupOptions) {
      this.selectedDealerGroup = []
      const id = parseInt(this.dealerGroup.split('/')[1], 10)

      for (const item of this.dealerGroupOptions) {
        if (item.id === id) {
          this.selectedDealerGroup.push(item)
        }
      }
      //  console.log('string', this.selectedDealerGroup)
    }
  }

  // public get positionData() {
  //   this.positions = MasterModule.PositionData.data;
  //   return MasterModule.PositionData;
  // }

  public select1 = 'hay'
  public placeHolder = 'Name'
  public get stateConfirm(): boolean {
    return this.passwordConfirm.length >= 6 &&
      this.passwordConfirm === this.password
      ? true
      : false
  }
  public get invalidConfirm(): string {
    if (this.passwordConfirm.length >= 6) {
      return 'Your Passowrd Not Match'
    } else if (this.passwordConfirm.length > 0) {
      return 'Enter at least 6 characters'
    } else {
      return ''
    }
  }
  public get validConfirm(): string {
    return this.stateConfirm === true ? '' : ''
  }

  public get stateCode(): boolean {
    return this.code.length >= 6 ? true : false
  }
  public get invalidCode(): string {
    if (this.code.length >= 6) {
      return 'Please Enter another Sales Code'
    } else if (this.code.length > 0) {
      return this.code + ' has been Existed. Try another one'
    } else {
      return ''
    }
  }
  public get validCode(): string {
    return this.stateCode === true ? '' : ''
  }

  public get needSalesCode() {
    const sales = AuthModule.salesCode.need_sales_code
    if (sales === true) {
      return true
    }
    return sales
  }

  public passwordType: string = 'password'
  public passwordTypeConfirm: string = 'password'
  public iconType: string = 'eye-slash'
  public iconTypeConfirm: string = 'eye-slash'
  public text: string = ''

  public optionsStatusEmployee: any = [
    { text: '- Select Status Employee -', value: '' },
    { text: 'Aktif', value: true },
    { text: 'Tidak Aktif', value: false },
  ]

  public items: any = [
    { text: '- Position -', value: '' },
    {
      value: 'Salesman',
      text: 'Salesman',
    },
    {
      value: 'Salesman Counter',
      text: 'Salesman Counter',
    },
    {
      value: 'Branch Manager',
      text: 'Branch Manager',
    },
    {
      value: 'Sales Manager',
      text: 'Sales Manager',
    },
    {
      value: 'Supervisor',
      text: 'Supervisor',
    },
  ]

  public optionsSalescode: any = [
    { text: '- Category -', value: '' },
    {
      value: 'MMKSI-',
      text: 'MMKSI',
    },
    {
      value: 'DLR-',
      text: 'DLR (Dealer)',
    },
    {
      value: 'Oth-',
      text: 'Oth (Other)',
    },
  ]

  @Validate({
    required,
  })
  public salescode: string = ''

  @Validate({
    required,
  })
  public code: string = ''

  @Validate({})
  public email: string = ''

  @Validate({
    required,
    minLength: minLength(6),
  })
  public password: string = ''

  @Validate({})
  public position: any = ''
  public position2: string = ''
  @Watch('position')
  public onPositionChanged(value: string, oldValue: string) {
    this.position = this.position2
  }

  @Validate({
    required,
  })
  public statusEmployee: string = ''

  @Validate({})
  public notes: string = ''

  @Validate({
    required,
  })
  public name: string = ''

  @Validate({})
  public phoneNumber: string = ''

  @Validate({
    required,
    sameAsPassword: sameAs('password'),
    minLength: minLength(6),
  })
  public passwordConfirm: string = ''

  public modalDelete = {
    id: 'modal-deletes',
  }

  public changePasswordType() {
    if (this.passwordType === 'password') {
      this.passwordType = 'text'
      this.iconType = 'eye'
    } else {
      this.passwordType = 'password'
      this.iconType = 'eye-slash'
    }
  }

  public changePasswordTypeConfirm() {
    if (this.passwordTypeConfirm === 'password') {
      this.passwordTypeConfirm = 'text'
      this.iconTypeConfirm = 'eye'
    } else {
      this.passwordTypeConfirm = 'password'
      this.iconTypeConfirm = 'eye-slash'
    }
  }

  public resetModal() {
    this.$v.salescode.$reset()
    this.$v.code.$reset()
    this.$v.email.$reset()
    this.$v.password.$reset()
    this.$v.position.$reset()
    this.$v.statusEmployee.$reset()
    this.$v.notes.$reset()
    this.$v.name.$reset()
    this.$v.phoneNumber.$reset()
    this.$v.passwordConfirm.$reset()
    this.$v.dealerGroup.$reset()

    this.salescode = ''
    this.code = ''
    this.email = ''
    this.password = ''
    this.position = null
    this.statusEmployee = ''
    this.notes = ''
    this.name = ''
    this.phoneNumber = ''
    this.passwordConfirm = ''
    this.dealerGroup = ''
    this.needregister = 'false'
  }
  // this method : function
  public funcDelete(item, index, button) {
    this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
  }

  public funcOke(item, index, button) {
    const ids = this.selected.map((i) => i.id)
    UserModule.deleteUser({ ids })
    this.$root.$emit('bv::hide::modal', this.modalDelete.id, button)
    this.clearRowSelected()
  }

  // POST USER HERE
  public postNewUser() {
    this.$v.salescode.$touch()
    this.$v.code.$touch()
    this.$v.email.$touch()
    this.$v.password.$touch()
    this.$v.position.$touch()
    this.$v.statusEmployee.$touch()
    this.$v.notes.$touch()
    this.$v.name.$touch()
    this.$v.phoneNumber.$touch()
    this.$v.passwordConfirm.$touch()
    this.$v.dealerGroup.$touch()
    if (
      this.$v.code.$invalid ||
      this.$v.salescode.$invalid ||
      this.$v.name.$invalid ||
      this.$v.password.$invalid ||
      this.$v.passwordConfirm.$invalid ||
      this.$v.position.$invalid ||
      this.$v.statusEmployee.$invalid
    ) {
      //  console.log('data harus diisi')
    } else {
      const dataToPost = {
        salesmanCode: this.salescode + this.code,
        salesmanName: this.name,
        email: this.email,
        phone: this.phoneNumber,
        password: this.password,
        passwordConfirmation: this.passwordConfirm,
        jobPositionId: this.position,
        dealerGroup: this.dealerGroup,
        isActive: this.statusEmployee,
        Notes: this.notes,
        Register: this.needregister,
        from: 'SFD',
      }
      UserModule.postUser(dataToPost)
      this.$root.$emit('bv::hide::modal', 'addNewUser')
    }
  }

  // IMPORT USER HERE
  public postImportFile() {
    const fileToPost = {
      fileName: this.hasFiles.file_name,
      fileByte: this.hasFiles.file_byte,
    }
    UserModule.postImport(fileToPost)
    this.$root.$emit('bv::hide::modal', 'addImportFile')
  }
}
